import React from 'react';
import {Hero} from "../../components/hero/Hero";
import {NewsListSection} from "../../components/news/NewsListSection";
import {ProductList} from "./ProductList";
import {connect} from 'react-redux';
import {ContactUsHiddenFormSection} from "../../components/contact-us/ContactUsHiddenFormSection";
import {CaseStoriesCarousel} from "../../components/case-stories/CaseStoriesCarousel";
import {Helmet} from "react-helmet";

class ProductCategoryContainer extends React.Component {

  constructor(props){
    super(props);

    this.fetchCaseStories = this.fetchCaseStories.bind(this);

    this.state = { // eslint-disable-next-line
      solution: this.props.solutions.find( solution => solution.slug === this.props.match.params.solution_slug ),
    };

    this.fetchCaseStories();
  }

  componentWillReceiveProps(nextProps) {
    const solution = nextProps.solutions.find( solution => solution.slug === nextProps.match.params.solution_slug );

    this.setState({ // eslint-disable-next-line
      solution,
    });

    if(this.state.solution !== solution){
      this.fetchCaseStories();
    }
  }

  fetchCaseStories(){
    let casestories = this.props.solution_products
      .map( p => {
        if(p.acf && Array.isArray(p.acf.related_posts))
          return p.acf.related_posts;
        return null;
      })
      .filter( p => p );

    casestories = [].concat.apply([], casestories);

    if( casestories.length > 0 ) {
      this.props.wpapi
        .news()
        .include(casestories)
        .then(response => {
          this.setState({
            related_case_stories: response
          })
        });
    }
  }

  render(){

    let mainImage;
    if (this.state.solution && this.state.solution.acf.sphnx_product_category_image) {
      mainImage = this.state.solution.acf.sphnx_product_category_image;
    }
/*
    let contentImage;
    if (this.state.solution && this.state.solution.acf.obx_content_image) {
      contentImage = this.state.solution.acf.obx_content_image;
    }
*/
    return (
      <div>

         <Helmet>
          <title>{this.state.solution && this.state.solution.name ? this.state.solution.name + " | Obelux Aviation Lights" : ""}</title>
          <meta name="description" content={this.state.solution && this.state.solution.description ? this.state.solution.description : ""}></meta>
          <meta name="og:description" content={this.state.solution && this.state.solution.description ? this.state.solution.description : ""}></meta>
          <meta name="og:image" content={mainImage ? mainImage.url : require('../../assets/images/obelux.jpg')}></meta>
        </Helmet>

        <header>
          <Hero title={this.state.solution && this.state.solution.name ? this.state.solution.name : ""}
                subtitle={this.state.solution && this.state.solution.description ? this.state.solution.description : ""}
                image={mainImage ? mainImage.url : require('../../assets/images/obelux-www-intro_contr.jpg')}
                align="center"
                className="medium-hero background-bottom"
          />
        </header>
        
        <ProductList solution_categories={this.props.solution_categories}
                     solution_products={this.props.solution_products}/>
        {/*<section className="about-container">
          <Container>
            <Row>
              <Col xs="7" className="pt-5">
                <SmallUnderline align="left">
                  <h1>{this.state.solution && this.state.solution.acf.obx_content_header ? this.state.solution.acf.obx_content_header : "" }</h1>
                </SmallUnderline>
                <p className="about-body"
                   dangerouslySetInnerHTML={{
                     __html: this.state.solution && this.state.solution.acf.obx_content_paragraph ? this.state.solution.acf.obx_content_paragraph : ""
                   }}>
                </p>
              </Col>
              <Col xs="5">
                {
                  Boolean(contentImage) &&
                  <img width="100%" src={contentImage ? contentImage.url : require('../../assets/images/led.png')} alt="obelux-led"/>
                }
              </Col>
            </Row>
          </Container>
        </section>*/}
        <ContactUsHiddenFormSection/>
        <CaseStoriesCarousel caseStoryList={this.state.related_case_stories}/>
        <NewsListSection/>
      </div>
    );
  }
}


export const ProductCategory = connect(
  state => ({
    solution_categories: ( state.resolve.data && state.resolve.data.solution_categories ) || [],
    solution_products: ( state.resolve.data && state.resolve.data.solution_products ) || [],
    solutions: ( state.resolve.data && state.resolve.data.solutions ) || [],
    wpapi: state.WPAPI.instance
  })
)(ProductCategoryContainer);



// WEBPACK FOOTER //
// ./src/views/products/ProductCategory.js